import {
  assemblyPrimaryDomainHostname,
  copilotPrimaryDomainHostname,
} from 'src/constants/hostnameConsts';

const apiIDForDev = '03n8zndl3l';
const apiIDForProd = 'gs1plashf3';
const websocketDevApiUrl = `${apiIDForDev}.execute-api.us-east-1.amazonaws.com/dev`;

const ApiUrlToWebSocketApiID: Record<string, string> = {
  [`https://app-api.${assemblyPrimaryDomainHostname.staging}`]:
    websocketDevApiUrl,
  [`https://app-api.${copilotPrimaryDomainHostname.staging}`]:
    websocketDevApiUrl,
  [`https://app-api.${assemblyPrimaryDomainHostname.prod}`]: `${apiIDForProd}.execute-api.us-west-2.amazonaws.com/production`,
  [`https://app-api.${copilotPrimaryDomainHostname.prod}`]: `${apiIDForProd}.execute-api.us-west-2.amazonaws.com/production`,
};

type ApiUrlToWebSocketApiID = typeof ApiUrlToWebSocketApiID;

export type ApiUrlToWebSocketApiIDKeys = keyof ApiUrlToWebSocketApiID;

interface GetWebSocketUrlInput {
  apiUrl: string;
  userId: string;
  wssEndpoint?: string;
}

const webSocketUrlHasProtocol = (url: string) => /^wss?:\/\//i.test(url);

const isLocalWebSocketEndpoint = (url: string) =>
  /^localhost(?::\d+)?(\/|$)/i.test(url) ||
  /^127\.0\.0\.1(?::\d+)?(\/|$)/.test(url);

/**
 * Given the core api url determine which websocket api id to use
 * when the input core api url does not match any of the keys in the
 * ApiUrlToWebSocketApiID object use the dev websocket api id
 * @param apiUrl the api url for core api
 * @param userId the current userId to connect to the websocket
 * @returns websocket url to connect to
 */
export const GetWebSocketUrl = ({
  apiUrl,
  userId,
  wssEndpoint,
}: GetWebSocketUrlInput) => {
  const websocketApiURL =
    wssEndpoint || ApiUrlToWebSocketApiID[apiUrl] || websocketDevApiUrl;
  const baseWebSocketUrl = webSocketUrlHasProtocol(websocketApiURL)
    ? websocketApiURL
    : `${isLocalWebSocketEndpoint(websocketApiURL) ? 'ws' : 'wss'}://${websocketApiURL}`;
  const encodedUserId = encodeURIComponent(userId);
  const querySeparator = baseWebSocketUrl.includes('?') ? '&' : '?';
  return `${baseWebSocketUrl}${querySeparator}userID=${encodedUserId}`;
};
